import { httpApi as nodeApi } from '@nucleus-care/nucleuscare-backend-client';

export type PatientNotesResponse = {
  ID: string;
  PatientID: string;
  NoteDate: Date;
  Note: string;
  UserID: string;
  UserName: string;
  PatientName: string;
  NoteType: string;
};

type SortDirection = 'asc' | 'desc';

type PatientNoteKeys = Extract<keyof PatientNotesResponse, string>;

export type PatientNotesSort = `${PatientNoteKeys}:${SortDirection}`;

export const getPatientNotesData = async ({
  accountId,
  startDate,
  endDate,
  searchText,
  sortBy = 'NoteDate:desc',
}: {
  accountId: string;
  startDate: Date;
  endDate: Date;
  sortBy?: PatientNotesSort;
  searchText?: string;
  page?: number;
  pageSize?: number;
}) => {
  let url = `report/patient-notes?accountId=${accountId}&startDate=${startDate}&endDate=${endDate}`;
  if (searchText) {
    url += `&search=${encodeURIComponent(searchText)}`;
  }
  if (sortBy) {
    url += `&sortBy=${encodeURIComponent(sortBy)}`;
  }
  const response = await nodeApi.get<PatientNotesResponse[]>(url, {
    timeout: 30000,
  });
  console.log('getPatientNotesData response', response.data);
  return response.data;
};
